<div class="content" [formGroup]="form">
  <div class="control-container">
    <div class="external-hint">
      {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.SEND_NOTIFICATION_TO' | translate }}
    </div>
    <automata-automation-replacement-chips
      label="AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.USER_TYPES.SALESPEOPLE"
      [dataService]="salespersonSelectorService"
      [formControl]="usersFormControl"
      [isRequired]="true"
      [supportedDataTypes]="supportedDataTypes"
      (finishedInitialLoading)="finishedInitialLoading()"
    ></automata-automation-replacement-chips>
  </div>
  <div class="control-container">
    <glxy-form-field>
      <glxy-label>
        {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.JOB_TITLE_LABEL' | translate }}
      </glxy-label>
      <input matInput [formControl]="jobTitleFormControl" required="false" />
    </glxy-form-field>
    <mat-hint class="external-hint">
      {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.JOB_TITLE_HINT' | translate }}
    </mat-hint>
  </div>
  <automata-send-notification-form
    #notificationForm
    [partnerId]="automation.namespace"
    [step]="step"
    [defaultLinkTemplate]="sscLinkTemplate"
    [userTypeKey]="'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.USER_TYPES.SALESPEOPLE'"
    [isSalesperson]="true"
  ></automata-send-notification-form>
</div>
